import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations, firestoreAction } from 'vuexfire'
import { db } from '@/firebase'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dialog: {
      isLoading: false,
      isShow: false,
      title: '',
      content: ''
    },
    forms: [],
    bookings: []
  },
  mutations: {
    ...vuexfireMutations,
    SHOW_DIALOG (state, { title = '', content = '' }) {
      state.dialog.isShow = true
      state.dialog.isLoading = false
      state.dialog.title = title
      state.dialog.content = content
    },
    CLOSE_DIALOG (state) {
      state.dialog.isShow = false
    },
    START_LOADING (state) {
      state.dialog.isShow = true
      state.dialog.isLoading = true
    }
  },
  actions: {
    bindForms: firestoreAction(({ bindFirestoreRef }) => {
      // return the promise returned by `bindFirestoreRef`
      return bindFirestoreRef('forms', db.collection('forms'))
    }),
    bindBookings: firestoreAction(({ bindFirestoreRef }) => {
      // return the promise returned by `bindFirestoreRef`
      return bindFirestoreRef('bookings', db.collection('bookings').orderBy('formId').orderBy('date').orderBy('time'))
    })
  },
  modules: {
  },
  getters: {
    dialog: (state) => { return state.dialog },
    forms: (state) => { return state.forms },
    getFormById: (state) => (formId) => {
      return state.forms.find(forms => forms.id === formId)
    },
    bookings: (state) => { return state.bookings }
  }
})
